//package imports 
import React, { useEffect, useState } from "react";


//component imports
import CustomTable from "../../utils/resuableComponents/CustomTable";
import {getUserType,getCityList,getStateList,getSeoData} from "../../services/apiServices/GetServices";
import { disableUser ,callSeoValueEdit} from "../../services/apiServices/PostServices";
import MetaDataEditModal from "../../utils/resuableComponents/MetaDataEditModal";
import {seoHeader } from "../../utils/constants/TableHeader";
import { showToast } from "../../utils/constants/Toaster";
import Loader from "../loadingScreens/Loader";


const SeoData = (props) => {
    const [seoListData, setSeolistData] = useState([])
    const[seoModalOpen,setSeoModalOpen]=useState(false)
    const[seoModalData,setSeoModalData]=useState([])
    const [isLoader,setIsLoader]=useState(false)

    useEffect(() => {
        getSeoListApi()
    }, []);
        
  
    //function to call api of the getUserList
    const getSeoListApi = async () => {
        setIsLoader(true)
        try{
            const res = await getSeoData("seo");
            if (res.success) {
               // setFilteredData(res?.data)
               setSeolistData(res?.seo)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
        
    }
    
    //function call to close seo edit modal
    const closeSeoModalEdit = () => {
        setSeoModalOpen(false)
    }

    //function call to open seo edit modal
    const handleSeoOpen = (data) => {
        setSeoModalData(data)
        setSeoModalOpen(true)
    }
   
    //function call to hit seo data update api
    const handleSeoEditActon = async (reqbody) => {
        try{
            const res = await callSeoValueEdit("seo",reqbody) 
            if(res?.success){
             showToast(1,res?.message)
             setSeoModalOpen(false)
             getSeoListApi()
            }else{
             console.log("res",res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
          
    }

    return (
        <div class="col-md-12 " >
            {isLoader ? <Loader/> : null }
            <div class="d-flex flex-row  justify-content-between align-items-center w-100 border-bottom p-2 my-1">
                <h1 class="fs-4 mx-3 Montserrat fw-semi-bold">
                   SEO
                </h1>
            </div>
                <MetaDataEditModal open={seoModalOpen} from="seo" data={seoModalData}  close={closeSeoModalEdit} onClickSave={handleSeoEditActon}  />
            <CustomTable data={seoListData} columnHeader={seoHeader} onClickSeoOpen={handleSeoOpen}/>
        </div>
    )
}

export default SeoData